import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './AdminWorkEditScreen';
import AdminWorkEdit from './AdminWorkEditScreen';
import { StoreState } from 'src/store/reducers';
import { getAdminWork } from 'src/store/actions/adminWork-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        adminWork: state.adminWorks.current,
        providers: state.providers.data,
        inProgress: state.adminWorks.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getAdminWork(id)),
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const AdminWorkEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(AdminWorkEdit);

export default AdminWorkEditScreen;
